import React, { Component } from 'react';
import DataTable from './datatable/DataTableTTT.jsx';
import { header } from 'constants/table';
import { Input, DropDown } from 'components/tt-forms/common';
import { RowItemDanhMucCuocThanhTraTrung } from 'modules/thanh-tra-trung/datatable';
import { Link, browserHistory } from 'react-router';
import { ThanhTra } from 'api';
import { API_URL } from 'constants/config';
import { Dialog } from "@blueprintjs/core";
import { get, isEmpty } from 'lodash';
import { connect } from 'react-redux';
import { Toastr } from 'modules/toastr';

class DanhMucCuocThanhTraTrung extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      soQuyetDinh: '',
      namThanhTra: '',
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      data: [],
      dataLichSuCu: [],
      doiTuongThannhTra: '',
      dsNamThanhTra: [],
      ttXuLyTTTCuaDonVi: [],
      trangThaiXuLyCuaDonVi: '',
      dataLichSuXuLy: [],
      listNhomDoiTuong: [],
      listNamThanhTra: [],
      selectListItem: [],
      tableLoading: false,
      donViIds: [],
      dataXuLy: [],
      checkAll: false,
      listSelected: [],
      namThanhTraXuLy: ''
    }
  }

  onChange(name, e) {
    if (name === 'donViThanhTra') {
      const { dataListDonVi } = this.state;
      const donViIds = [...this.state.donViIds];
      const selectListItem = [...this.state.selectListItem];
      const checkItem = selectListItem.findIndex(item => Number(item.coQuanQuanLyId) === Number(e.target.value));
      if (checkItem === -1) {
        const selectItem = dataListDonVi.find(item => Number(item.coQuanQuanLyId) === Number(e.target.value));
        selectListItem.push(selectItem);
        donViIds.push(selectItem.coQuanQuanLyId);
      }
      this.setState({
        donViIds,
        selectListItem
      });
    } else {
      this.setState({
        [name]: e.target.value
      });
    }
  }

  handleExport() {
    let URL = `${String(API_URL)}/cuocThanhTraTrungDoiTuong/xuatExcel?tenDoiTuongThanhTra=${this.state.doiTuongThannhTra}`;
    if (this.state.soQuyetDinh) {
      URL = `${URL}&soQuyetDinhPheDuyetKHTT=${this.state.soQuyetDinh}`;
    }
    if (this.state.nhomDoiTuong) {
      URL = `${URL}&nhomDoiTuongId=${this.state.nhomDoiTuong}`;
    }
    if (this.state.trangThaiXuLyCuaDonVi) {
      URL = `${URL}&trangThaiXuLyCuaDonVi=${this.state.trangThaiXuLyCuaDonVi}`;
    }
    if (!isEmpty(this.state.donViIds)) {
      URL = `${URL}&donViIds=${this.state.donViIds}`;
    }
    window.open(URL, "_self");
  }

  async componentDidMount() {
    await this.getlichSuXuLyCTTTrungCurrent();
    await this.getDataList();
    this.getNamThanhTraList();
    this.getTTXuLyTrungTaiDV();
    this.getLichSuXuLyCTTT();
    this.getNhomDoiTuong();
    this.getDonVi();
    this.getCuocThanhTraTrung();
    this.checkNamThanhTraXuLy();
  }

  checkNamThanhTraXuLy() {
    ThanhTra.actions.getHienThiKeHoachThanhTra.request().then(res => {
      if (!isEmpty(res.data)) {
        this.setState({
          namThanhTraXuLy: get(res, 'data.namThanhTra')
        });
      }
    });
  }

  getNamThanhTraList() {
    ThanhTra.actions.getNamThanhTra.request().then(res => {
      if (!isEmpty(res.data)) {
        this.setState({
          listNamThanhTra: res.data
        });
      }
    });
  }

  getCuocThanhTraTrung() {
    let params = {};
    this.setState({
      tableLoading: true
    });
    ThanhTra.actions.getCuocThanhTraTrungXuLy.request('', params).then(res => {
      if (!isEmpty(res.data._embedded)) {
        let data = get(res, 'data._embedded.medial_CuocThanhTraTrungInfoes') || [];
        const tableLoading = false;
        this.setState({
          dataXuLy: data,
          tableLoading
        });
      } else {
        const tableLoading = false;
        this.setState({
          dataXuLy: [],
          tableLoading
        });
      }
    });
  }

  getTTXuLyTrungTaiDV() {
    ThanhTra.actions.getTrangThaoXuLyTrungTaiDV.request().then(res => {
      if (!isEmpty(res.data)) {
        const newData = res.data.filter(item => item.giaTri !== "DA_XOA");
        this.setState({
          ttXuLyTTTCuaDonVi: newData
        });
      }
    });
  }

  getNhomDoiTuong() {
    ThanhTra.actions.getNhomDoiTuongThanhTras.request().then(res => {
      const listNhomDoiTuong = get(res, 'data._embedded.nhomDoiTuongThanhTras') || [];
      this.setState({ listNhomDoiTuong });
    });
  }

  getDataList(isSearch = false) {
    let params = {
      page: this.state.pageData.number,
      size: this.state.pageData.size,
    };
    if (this.state.doiTuongThannhTra) {
      params.tenDoiTuongThanhTra = this.state.doiTuongThannhTra;
    }
    if (this.state.soQuyetDinh) {
      params.soQuyetDinhPheDuyetKHTT = this.state.soQuyetDinh;
    }
    if (this.state.nhomDoiTuong) {
      params.nhomDoiTuongId = Number(this.state.nhomDoiTuong);
    }
    if (this.state.trangThaiXuLyCuaDonVi) {
      params.trangThaiXuLyCuaDonVi = this.state.trangThaiXuLyCuaDonVi;
    }
    if (!isEmpty(this.state.namThanhTra)) {
      params.namThanhTra = this.state.namThanhTra;
    }
    if (!isEmpty(this.state.selectListItem)) {
      const { selectListItem } = this.state;
      const arrDonVis = selectListItem.map(item => get(item, 'coQuanQuanLyId'));
      params.donViIds = arrDonVis.join(',');
    }
    this.setState({
      tableLoading: true
    })
    ThanhTra.actions.getDSCuocThanhTraTrung.request(null, params).then(res => {
      if (!isEmpty(res.data._embedded)) {
        let data = get(res, 'data._embedded.medial_CuocThanhTraTrungInfoes');
        const pageData = get(res, 'data.page');
        const tableLoading = false;
        const selectData = data.map(item => {
          if (this.state.listSelected.includes(get(item, 'doiTuongThanhTraTrung.doiTuongThanhTraId'))) {
            return {
              ...item,
              selected: true
            };
          }
          return item;
        });
        if (this.state.dataSave && !isSearch) {
          this.props.dispatch({
            type: 'ADD_DANH_SACH_TTT_SELECTED',
            data: this.state.listSelected
          });
        }
        this.setState({
          data: this.state.dataSave ? selectData : data,
          pageData,
          tableLoading
        });
      } else {
        const tableLoading = false;
        this.setState({
          data: [],
          pageData: {
            number: 0,
            size: 10,
            totalElements: 0
          },
          tableLoading
        });
      }
    });
  }

  getlichSuXuLyCTTTrungCurrent() {
    ThanhTra.actions.getlichSuXuLyCTTTrungCurrent.request().then(res => {
      if (!isEmpty(res.data)) {
        this.setState({
          listSelected: res.data.idDoiTuongXuLys,
          dataSave: res.data
        });
        this.props.dispatch({
          type: 'ADD_DANH_SACH_TTT_SELECTED',
          data: res.data.idDoiTuongXuLys
        });
      }
    });
  }

  getLichSuXuLyCTTT() {
    ThanhTra.actions.getLichSuXuLyCTTTrung.request().then(res => {
      if (!isEmpty(res.data._embedded)) {
        let data = res.data._embedded;
        this.setState({
          dataLichSuXuLy: data.lichSuXuLyCTTTrungs,
          lanXuly: get(data, 'lichSuXuLyCTTTrungs[0].lanXuLy')
        });
      }
    });
  }

  getDonVi() {
    ThanhTra.actions.getKHTTDonVi.request().then(res => {
      if (!isEmpty(res.data._embedded)) {
        const dataListDonVi = get(res, 'data._embedded.coQuanQuanLies');
        this.setState({ dataListDonVi });
      }
    });
  }

  handlePageClick(page) {
    this.setState({
      pageData: {
        ...this.state.pageData,
        number: page.selected
      }
    }, () => {
      this.getDataList(true);
    })
  }

  handleChangePageSize(size) {
    this.setState({
      pageData: {
        ...this.state.pageData,
        size,
        number: 0
      }
    }, () => {
      this.getDataList(true);
    });
  }

  handleSelectedAll() {
    const { data } = this.state;
    const listSelectTTT = JSON.parse(localStorage.getItem('listSelectThanhTraTrung')) || [];
    const newListSelected = [...listSelectTTT];
    const listData = data.map(item => {
      const checkSelected = listSelectTTT.includes(item.doiTuongThanhTraTrung.doiTuongThanhTraId);
      const statusSelected = () => {
        if (item.namThanhTra === this.state.namThanhTraXuLy) {
          return checkSelected ? true : !this.state.checkAll
        }
        return false;
      };
      if (!this.state.checkAll && !checkSelected && item.namThanhTra === this.state.namThanhTraXuLy) {
        newListSelected.push(item.doiTuongThanhTraTrung.doiTuongThanhTraId);
      }
      return {
        ...item,
        selected: statusSelected()
      }
    })
    this.setState({
      data: listData,
      checkAll: !this.state.checkAll,
      listSelected: newListSelected
    });
  }

  openDialog() {
    if (!isEmpty(this.state.listSelected)) {
      this.props.dispatch({
        type: 'ADD_DANH_SACH_TTT_SELECTED',
        data: this.state.listSelected
      });
      if (!isEmpty(this.state.dataLichSuXuLy)) {
        this.setState({
          openDialog: true
        });
      } else {
        browserHistory.push("/thanh-tra/danh-muc-cuoc-thanh-tra-trung/xu-ly");
      }
    } else {
      Toastr('Chưa chọn đối tượng trùng', 'warning');
    }
  }

  async handleContinue() {
    await this.props.dispatch({
      type: 'ADD_DANH_SACH_TTT_SELECTED',
      data: this.state.listSelected
    });
    browserHistory.push("/thanh-tra/danh-muc-cuoc-thanh-tra-trung/tiep-tuc-xu-ly");
  }

  handleSearch() {
    this.getDataList(true);
  }

  closeDialog(name) {
    if (name === 'dongY') {
      browserHistory.push("/thanh-tra/danh-muc-cuoc-thanh-tra-trung/xu-ly");
    }
    if (name === 'khong') {
      localStorage.removeItem('listSelectThanhTraTrung');
    }
    this.setState({
      openDialog: false
    });
  }

  removeDonVi(index) {
    const selectListItem = [...this.state.selectListItem];
    const donViIds = [...this.state.donViIds];
    selectListItem.splice(index, 1);
    donViIds.splice(index, 1);
    this.setState({
      donViIds,
      selectListItem
    });
  }

  async handleSelectedDoiTuong(item) {
    item.selected = !item.selected;
    const { data, listSelected } = this.state;
    const newListData = data.map(state => {
      if (get(state, 'doiTuongThanhTraTrung.doiTuongThanhTraId') === get(item, 'doiTuongThanhTraTrung.doiTuongThanhTraId')) {
        if (item.selected) {
          listSelected.push(state.doiTuongThanhTraTrung.doiTuongThanhTraId);
        } else {
          const index = listSelected.indexOf(state.doiTuongThanhTraTrung.doiTuongThanhTraId);
          if (index > -1) {
            listSelected.splice(index, 1);
          }
        }
        return state = {
          ...state,
          selected: item.selected
        };
      }
      return state;
    });
    this.setState({
      data: newListData,
      listSelected
    })
  }

  render() {
    const showXuLy = !isEmpty(this.state.dataXuLy);
    const btnTiepTuc = !!this.state.dataSave;
    return (
      <div className="center reception-container" ref="dskhtt">
        <Dialog
          isOpen={this.state.openDialog}
          onClose={this.closeDialog.bind(this)}
          title='Thông báo'
          className="reception-dialog delete-dialog wrap-block"
        >
          <div className="pt-dialog-body mb0 xuLyDialog">
            <div className='pt10 pb20 txt-center'>
              {`Bạn chắc chắn tất cả các đơn vị đã xử lý trùng lặp ${this.state.lanXuly} và muốn tiếp tục xử lý trùng lặp !`}
            </div>
          </div>
          <div className="box-bottom col-100">
            <Link className="btn-action btn-close action-todo" onClick={this.closeDialog.bind(this, 'khong')}><span>Không</span></Link>
            <Link className="btn-action btn-green action-todo" onClick={this.closeDialog.bind(this, 'dongY')}><span>Đồng ý</span></Link>
          </div>
        </Dialog>
        <div className="top-content">
          <div className="left-content">
            <p className="title-18"><i className="tt tt-thanh-tra"></i>Danh mục cuộc thanh tra/kiểm tra trùng</p>
          </div>
        </div>
        <div className="bottom-content">
          <div className="wrap-block pl15 pr15 pt20">
            <div className="row pl10 pr10">
              <div className="col-83 no-gutter">
                <Input className="col-25" label="Đối tượng thanh tra/kiểm tra" placeholder="Nhập tên đối tượng..." value={this.state.doiTuongThannhTra} onChange={this.onChange.bind(this, 'doiTuongThannhTra')} name="doiTuongThannhTra" />
                <Input className="col-25" label="Số quyết định phê duyệt KHTT/KHKT" placeholder="Nhập..." value={this.state.soQuyetDinh} onChange={this.onChange.bind(this, 'soQuyetDinh')} name="soQuyetDinh" maxLength={255} />
                <DropDown className="col-25 mb18" label="Nhóm đối tượng" options={this.state.listNhomDoiTuong} keyName="nhomDoiTuongThanhTraId" valueName="ten" selectedValue={this.state.nhomDoiTuong} onChange={this.onChange.bind(this, 'nhomDoiTuong')} placeholder />
                <DropDown className="col-25 mb18" label="Trạng thái xử lý trùng tại đơn vị" options={this.state.ttXuLyTTTCuaDonVi} keyName="giaTri" valueName="ten" selectedValue={this.state.trangThaiXuLyCuaDonVi} onChange={this.onChange.bind(this, 'trangThaiXuLyCuaDonVi')} placeholder />
              </div>
              <div className="col-16 mb0-18 search-thanh-tra">
                <button className="btn-green" onClick={this.handleSearch.bind(this)}>
                  <i className="tt-search"></i>Tìm kiếm
                </button>
              </div>
              <div className="wrap-tt-dvph col-83 no-gutter">
                <DropDown className="col-25" label="Năm thanh tra/kiểm tra" options={this.state.listNamThanhTra} keyName="giaTri" valueName="ten" selectedValue={this.state.namThanhTra} onChange={this.onChange.bind(this, 'namThanhTra')} placeholder />
                <DropDown className="col-25 mb18" label="Đơn vị thanh tra/kiểm tra" options={this.state.dataListDonVi} keyName="coQuanQuanLyId" valueName="ten" onChange={this.onChange.bind(this, 'donViThanhTra')} placeholder />
                <div className="col-50 mb18">
                  <div className="ds-tt-dvph">
                    {
                      this.state.selectListItem.map((item, index) => {
                        return (
                          <div className="tt-dvph-item" key={index}>
                            <span className="tt-dvph-icon" onClick={this.removeDonVi.bind(this, index)}>×</span>
                            <span className="tt-dvph-value">{item.ten}</span>
                          </div>
                        )
                      })
                    }
                  </div>
                </div>
              </div>
            </div>
            <div className='row'>
              <span className="line-border"></span>
            </div>
          </div>
          <DataTable
            header={header.thanhTraTrung.DMCTTT}
            handleExport={this.handleExport.bind(this)}
            dataList={this.state.data}
            exporttext="Xuất Excel"
            thanhTra
            showXuLy={showXuLy}
            openDialog={this.openDialog.bind(this)}
            btnTiepTuc={btnTiepTuc}
            hideButtonExport
            pageData={this.state.pageData}
            parent={this}
            search
            handleContinue={this.handleContinue.bind(this)}
            selectAllStatus={this.state.checkAll}
            onCheck={this.handleSelectedAll.bind(this)}
            namThanhTra={this.state.namThanhTra}
            tableLoading={this.state.tableLoading}>
            <RowItemDanhMucCuocThanhTraTrung namThanhTraXuLy={this.state.namThanhTraXuLy} listSelected={this.state.listSelected} />
          </DataTable>
        </div>
      </div>
    )
  }
}

export default connect()(DanhMucCuocThanhTraTrung);


// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra-trung/DanhMucCuocThanhTraTrung.jsx